module.exports = __webpack_public_path__ + "e63698daafb85f7734290adff0f7c0f0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-19.png
// module id = 3095
// module chunks = 0